<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <div class="mb-12 mb-lg-20 pt-4">
                    <v-badge floating dot>
                        <h4 class="tit--sm line-height-1">근로자 계약서</h4>
                    </v-badge>
                </div>
                <vertical-form-table v-model="form" v-bind="{ items }" class="flex-grow-1">
                    <template slot="계약서 명칭">
                        <v-text-field v-model="form.name" v-bind="attrs_input"></v-text-field>
                    </template>
                    <template slot="계약서 파일">
                        <v-file-input v-model="form.file" @change="initField" v-bind="attrs_input"></v-file-input>
                    </template>
                    <template slot="계약서 필드">
                        <employment-form-pdf-page
                            v-for="page in pages"
                            v-bind="{ page, scale, pageNumber: page.pageNumber }"
                            :key="page.pageNumber"
                            :propsFields="propsFields"
                            @pageMeta="pageMeta"
                            @update="update"
                        />
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false"><span class="grey-6--text">취소하기</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="save"><span>저장하기</span></v-btn>
            </div>
            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, initEmploymentForm } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import EmploymentFormPdfPage from './employment-form-pdf-page.vue'

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js"
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry"

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


const items = [
    {
        key: "name",
        term: "계약서 명칭",
        type: "text",
    },
    {
        key: "file",
        term: "계약서 파일",
        type: "file",
    },
    {
        key: "pages",
        term: "계약서 필드",
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        EmploymentFormPdfPage
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
        fields:[],          // child -> parent field
        meta: [],           // page info
        propsFields: [],    // parent -> child field

        pdf: undefined,
        pages: [],

        items,
        attrs_input,
        shows: false,
        loading: false,
        scale: 3,
    }),
    created(){
        this.fetchPDF();
    },
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "근로자 계약서 ";
            title += this.isCreate ? "생성하기" : "수정하기";
            return title;
        },
        url(){
            return this.form.file ? URL.createObjectURL(this.form.file) : null;
        }
    },
    watch: {
        shows() {
            if (this.shows) {
                this.init();
                this.initField();
            }
            else if (this.form?._id) this.$emit("input", this.form);
        },
        url(){
            this.fetchPDF();
        },
        pdf(pdf){
            this.pages= [];
            let promises = [];
            for( let i=1; i<pdf.numPages+1; i++){
                promises.push(pdf.getPage(i));
            }

            Promise.all(promises).then( pages => ( this.pages = pages ));
        },
        // fields(){
        //      this.form.fields = this.fields.length === 0 ? this.propsFields : [];
        // }
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.isCreate) this.form = initEmploymentForm();
                else {
                    let [ { form }, { file } ] = await Promise.all([
                        api.v1.company.employment.forms.get({ _id: this.value?._id }),
                        api.v1.company.employment.files.get({ _id: this.value?._id })
                    ])

                    if (file) form.file = await api.getResource(file.url, true);
                    this.form = initEmploymentForm(form);
                    this.form.pages= [];

                    this.propsFields = this.form.fields;

                    this.form.fields = [];
                }
            } finally {
                this.loading = false;
            }
        },
        async save() {
            this.loading = true;
            try {
                let { ...form } = this.form;
                this.formatFormField();
                this.form.pages = this.form.pages.sort((a,b)=> a.page - b.page);
                
                let getForm= {};

                let { post, put } = api.v1.company.employment.forms;
                
                (await (!form._id ? post : put)(form).then(async({ form })=>{
                    getForm= form;
                    let { file }= await api.v1.company.employment.files.post({ _employmentForm: form._id}, this.form.file)
                }))
                this.form = getForm;
                
                this.pages = [];
                this.fields = [];

                this.shows = false;
            } finally {
                this.loading = false;
            }
        },
        async fetchPDF(){
            this.pdf = await pdfjsLib.getDocument({ url: this.url }).promise;
        },
        initField(){
            this.form.fields = [];
            this.form.pages= [];
        },
        update(valueArr){
            const idx= this.fields.findIndex((fieldArr)=> fieldArr[0].page === valueArr[0].page);
            if(idx === -1){
                this.fields.push(valueArr);
            } else{
                this.fields[idx] = valueArr;
            }
        },
        pageMeta(value){
            this.form.pages.push(value);
        },
        formatFormField(){
            this.fields.map((fieldArr)=>{
                fieldArr.map((field)=>{
                    this.form.fields.push(field);
                })
            })
        },
        
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
